/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { ReactNode } from "react";
import textContainerStyle from "./textContainerStyle";
import { Box, Theme } from "@mui/material";
import { SxProps } from "@mui/system";

type TextContainerProps = {
  sx?: SxProps<Theme>;
  children: ReactNode;
};

const TextContainer = ({ sx = {}, children }: TextContainerProps) => {
  return <Box sx={{ ...textContainerStyle.textContainer, ...sx }}>{children}</Box>;
};

export default TextContainer;
